// Italian formatting helpers
export function formatDateIt(iso) {
    if (!iso) return "—";
    const d = new Date(iso);
    if (isNaN(d)) return "—";
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
}

export function formatDateTimeIt(iso) {
    if (!iso) return "—";
    const d = new Date(iso);
    if (isNaN(d)) return "—";
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, "0");
    const min = String(d.getMinutes()).padStart(2, "0");
    return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
}

export function initials(first, last) {
    const a = (first || "").trim();
    const b = (last || "").trim();
    return ((a[0] || "") + (b[0] || "")).toUpperCase() || "?";
}

export function stringToColor(str) {
    const s = str || "";
    let h = 0;
    for (let i = 0; i < s.length; i++) h = s.charCodeAt(i) + ((h << 5) - h);
    const hue = Math.abs(h) % 360;
    return `hsl(${hue} 45% 55%)`;
}

export const LEAD_RANKING_LABEL = {
    caldo: "Caldo",
    tiepido: "Tiepido",
    freddo: "Freddo",
};

export const LEAD_RANKING_CLASS = {
    caldo: "text-orange-700 bg-orange-50 border-orange-200",
    tiepido: "text-amber-700 bg-amber-50 border-amber-200",
    freddo: "text-blue-700 bg-blue-50 border-blue-200",
};

export const TASK_TYPES = [
    { key: "semplice", label: "Semplice", cls: "text-neutral-600 bg-neutral-100 border-neutral-200", icon: "circle" },
    { key: "primaria", label: "Primaria", cls: "text-red-700 bg-red-50 border-red-200", icon: "flag" },
    { key: "prerequisito", label: "Prerequisito", cls: "text-indigo-700 bg-indigo-50 border-indigo-200", icon: "shield" },
    { key: "condizionale", label: "Condizionale", cls: "text-amber-700 bg-amber-50 border-amber-200", icon: "help-circle" },
    { key: "approvazione", label: "Approvazione", cls: "text-pink-700 bg-pink-50 border-pink-200", icon: "check-check" },
    { key: "traguardo", label: "Traguardo", cls: "text-emerald-700 bg-emerald-50 border-emerald-200", icon: "trophy" },
    { key: "revisione", label: "Revisione", cls: "text-purple-700 bg-purple-50 border-purple-200", icon: "refresh-cw" },
];

export function taskTypeMeta(key) {
    return TASK_TYPES.find((t) => t.key === key) || TASK_TYPES[0];
}

export function productivityRatio(estimated, actual) {
    if (!estimated || !actual) return null;
    return estimated / actual;
}

export function productivityClass(ratio) {
    if (ratio == null) return "text-neutral-500";
    if (ratio >= 1.1) return "text-emerald-600 font-medium";
    if (ratio < 0.85) return "text-red-600 font-medium";
    return "text-neutral-700 font-medium";
}
